import React, { useState } from "react";
import ButtonPrimary from "../components/Button-primary";

const DeltaNeutralCalculator = () => {
  const [capital, setCapital] = useState(1000);
  const [leverage, setLeverage] = useState(3);
  const [spotInvestment, setSpotInvestment] = useState(0);
  const [marginRequired, setMarginRequired] = useState(0);

  const calculateAllocation = () => {
    const spot = (capital * leverage) / (leverage + 1);
    const margin = capital - spot;

    setSpotInvestment(spot);
    setMarginRequired(margin);
  };

  return (
    <div className="flex flex-wrap max-w-md gap-4 p-4 px-4 mx-auto mt-2 border-2 border-gray-200 rounded-md">
      <h2 className="m-auto text-xl font-bold">
        Delta Neutral Strategy Calculator
      </h2>
      <div className="w-full">
        <label className="label-1">Total Capital ($):</label>
        <input
          className="input-1"
          type="number"
          value={capital}
          onChange={(e) => setCapital(Number(e.target.value))}
        />
      </div>
      <div className="w-full">
        <label className="label-1"> Leverage (x):</label>
        <input
          className="input-1"
          type="number"
          value={leverage}
          onChange={(e) => setLeverage(Number(e.target.value))}
        />
      </div>
      <div className="flex justify-center w-full">
        <ButtonPrimary text={"Calculate"} func={calculateAllocation} />
      </div>
      {(spotInvestment !==0 && marginRequired !== 0) && (
        <div>
          <p><span className="font-bold">Spot Investment: </span>${spotInvestment.toFixed(2)}</p>
          <p><span className="font-bold">Margin Required for Short: </span>${marginRequired.toFixed(2)}</p>
        </div>
      )}
    </div>
  );
};

export default DeltaNeutralCalculator;
